import { Link } from '@tanstack/react-router';
import { useLayoutEffect } from 'react';

// If needed we can use here page `InternalServerErrorPage` from @mint-lib/error-boundary

type Props = Readonly<{
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;
}>;

export default function ErrorComponent({ error }: Props) {
  useLayoutEffect(() => {
    console.error('router', error);
    // TODO: remove after cloudfront
    if (error.message.includes('Failed to fetch dynamically imported module')) {
      globalThis.location.reload();
      return;
    }
  }, [error]);

  if (error.message.includes('Failed to fetch dynamically imported module')) {
    return <div />;
  }

  return (
    <div className="bg-muted flex min-h-screen items-center justify-center">
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold text-red-500">500</h1>
        <p className="text-muted-foreground mb-4 text-xl">
          Oops! Something went wrong!
        </p>
        <Link to="/" className="text-primary hover:text-primary/90 underline">
          Return to Home
        </Link>
      </div>
    </div>
  );
}
